module.exports = __webpack_public_path__ + "static/media/Spend.961074ea.svg";